import { AudienceRuleSetOperator } from '@/store/models/interfaces/audience.interface';
import { IRuleSet } from '@/store/models/interfaces';

export class RuleSet implements IRuleSet {
    id: number;
    parentId: number | null;
    ruleType: 'ruleSet' = 'ruleSet';
    operator: AudienceRuleSetOperator;
}
